export const TARGET_ACTIVITY_DEFAULT_COUNT = 20
export const TARGET_ACTIVITY_LOAD_MORE_INCREMENT = 20
